<div class="flex text-sm lg:text-md info-box-text text-center">
    <app-info-icon tooltipClass="mr-2.5 mt-[2px] cursor-auto" [tooltipInfo]="infoText()"></app-info-icon>
    {{infoText()}}
    <ng-content></ng-content>
</div>